import { createSignal, onMount } from "solid-js";
import { useApplication } from "@/context/app";
import {
  Card,
  CardContent,
} from "@/components/shadcn/card";
import { activateAction, deactivateAction, deleteAction } from "../../components/ui/actions/config";
import { ListControl } from "../../components/ui/list/ListControl";
import { TableView } from "../../components/ui/list/TableView";
import { getHistoryColumns } from "./columns";
import { CreateModalTrigger } from "../../components/ui/Button";
import { HistoryModal } from "./modal";

export default function HistoryList() {

  const [listControl, setListControl] = createSignal(null);

  const [showCreateModal, openCreateModal] = createSignal(false);
  const [key, setKey] = createSignal(null);
  const { setBreadcrumb } = useApplication();

  const actions = [
    deactivateAction('history', 'history'),
    activateAction('history', 'history'),
    deleteAction('history', 'history')
  ];

  const onModalEdit = (key) => {
    setKey(null);
    setKey(key);
    openCreateModal(true);
  }

  const statuses = [{
    text: 'Active',
    value: true
  }, {
    text: 'Inactive',
    value: false
  }];

  onMount(async () => {
    setBreadcrumb([
      {
        name: 'Home',
        link: '/home'
      },
      {
        name: 'Questions',
        current: true
      }
    ]);
  });

  return (
    <>
      <div class="flex">
        <CreateModalTrigger onClick={() => { setKey(null); openCreateModal(true); }}>New Question</CreateModalTrigger>
        <HistoryModal key={key()} open={showCreateModal()} onRefresh={() => { listControl().refresh() }} onClose={() => openCreateModal(false)} />
      </div>
      <Card class="w-full">
        <CardContent>
          <ListControl
            ref={setListControl}
            search={''}
            mode="table"
            actions={actions}
            filters={[
              {
                type: 'choice',
                label: 'Status',
                name: 'status',
                choices: statuses,
                default: null
              },
              {
                type: 'date',
                label: 'Created At',
                name: 'created_at',
                default: null
              }
            ]}
            sort={{
              column: 'created_at',
              direction: 'asc'
            }}
            pagination={{
              current: 1, // default 1
              changePerPage: true, // default true
              perPage: 10, // default 10
              options: [10, 20, 50, 100]
            }}
            datasource={{
              type: 'remote',
              config: {
                url: '/history/fetch',
                method: 'GET',
                params: {
                  //status: status()
                }
              }
            }}
          >{(innerProps) => <TableView actionKey='key' {...innerProps} columns={getHistoryColumns({ onListAction: innerProps.onAction, onEdit: onModalEdit })} />}
          </ListControl>
        </CardContent>
      </Card>
    </>
  );
}
